import { render, staticRenderFns } from "./NewsPrompt.vue?vue&type=template&id=2b739f6c&"
import script from "./NewsPrompt.vue?vue&type=script&lang=js&"
export * from "./NewsPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports